import sidebar from '@/config/sidebars/formTracking'
import createVueApp from '@/common/createApp'

Styxie.Initializers.FormTrackingWidgets = {
  index: async(props) => {
    const { default: WidgetsIndex } = await import('@/vue_widgets/form_tracking/widgets/index.vue')
    createVueApp(WidgetsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: WidgetsShow } = await import('@/vue_widgets/form_tracking/widgets/show.vue')
    createVueApp(WidgetsShow, { props, sidebar })
  },
  new: async(props) => {
    const { default: WidgetsForm } = await import('@/vue_widgets/form_tracking/widgets/form.vue')
    createVueApp(WidgetsForm, { props, sidebar })
  },
  edit: async(props) => {
    const { default: WidgetsForm } = await import('@/vue_widgets/form_tracking/widgets/form.vue')
    createVueApp(WidgetsForm, { props, sidebar })
  }
}
